export const GET_ALL_INVOICES: string = 'src/pages/bundles/GET_ALL_INVOICES';
export const GET_ALL_INVOICES_SUCCESS: string =
  'src/pages/bundles/GET_ALL_INVOICES_SUCCESS';
export const GET_ALL_INVOICES_FAILED: string =
  'src/pages/bundles/GET_ALL_INVOICES_FAILED';

export const GET_INVOICES_WITH_ID: string =
  'src/pages/bundles/GET_ALL_INVOICES_WITH_ID';
export const GET_INVOICES_WITH_ID_SUCCESS: string =
  'src/pages/bundles/GET_ALL_INVOICES_WITH_ID_SUCCESS';
export const GET_INVOICES_WITH_ID_FAILED: string =
  'src/pages/bundles/GET_ALL_INVOICES_WITH_ID_FAILED';

export const UPDATE_INVOICES: string = 'src/pages/bundles/UPDATE_INVOICES';
export const UPDATE_INVOICES_SUCCESS: string =
  'src/pages/bundles/UPDATE_INVOICES_SUCCESS';
export const UPDATE_INVOICES_FAILED: string =
  'src/pages/bundles/UPDATE_INVOICES_FAILED';

export const CREATE_INVOICES: string = 'src/pages/bundles/CREATE_INVOICES';
export const CREATE_INVOICES_SUCCESS: string =
  'src/pages/bundles/CREATE_INVOICES_SUCCESS';
export const CREATE_INVOICES_FAILED: string =
  'src/pages/bundles/CREATE_INVOICES_FAILED';

export const GET_INVOICES_LOGS: string = 'src/pages/bundles/GET_INVOICES_LOGS';
export const GET_INVOICES_LOGS_SUCCESS: string =
  'src/pages/bundles/GET_INVOICES_LOGS_SUCCESS';
export const GET_INVOICES_LOGS_FAILED: string =
  'src/pages/bundles/GET_INVOICES_LOGS_FAILED';


export const GET_INVOICES_FILE: string = 'src/pages/bundles/GET_INVOICES_FILE';
export const GET_INVOICES_FILE_SUCCESS: string =
  'src/pages/bundles/GET_INVOICES_FILE_SUCCESS';
export const GET_INVOICES_FILE_FAILED: string =
  'src/pages/bundles/GET_INVOICES_FILE_FAILED';
